/**
* @file lightbox.js
* Custom Lightbox JS
* @author Tyler Akin 2018-10-16
* Converted to Vanilla JS by Danny Poit 2023-03-16
*
*	How To:
*		This following custom lightbox script provides a clean lightbox for
*			expanding images, including a resizing function to keep the lightbox
*			at the center of any screen size, as (I guess!) it should be.
*
*		Currently, the lightbox functionality is used in conjunction with
*			layout-image-gallery.php, which is a custom layout included in the
*			acf-flex subfolder located within the views folder.
*
*		Use:
*			This functionality is optional. In the Wordpress CMS, there is an
*				ACF special class entitled Light Box (.light-box is the
*				cooresponding class name).  If this class is added to an Image
*				Gallery layout, the following lightbox script will be enabled.
*
*			Note: When added, the .light-box class is added to the outermost
*				div of the Image Gallery.
*/

// Lightbox Functionality
var lightBoxElements = document.querySelectorAll('.light-box');

// Checks to see if the class has been added in the CMS
lightBoxElements.forEach(function(lightBoxElement) {
    var images = lightBoxElement.querySelectorAll('.image-gallery__image');
    images.forEach(function(image) {
        image.addEventListener('click', function() {
            // Get the source of the img from the image clicked and set it in a variable
            var largeImage = image.querySelector('img').getAttribute('src');
            
            // Adds a class to display the individual lightbox
            image.nextElementSibling.classList.add('opened-box');
            
            // Set the next largeImage element within the lightbox to the src of the image clicked
            var openedImgCntnr = document.querySelector('.opened-box .image-container');
            openedImgCntnr.querySelector('.largeImage').setAttribute('src', largeImage);
            
            // Check if image is first and if so, remove left arrow
            if (image == images[0]) openedImgCntnr.getC
            
            // Check if image is last and if so, remove left arrow
            if (image == images[images.length - 1]) console.log( 'last' );
            
            
            
            // Strip any previously clicked lightboxes of their image src
            document.querySelectorAll('.individual-lightbox:not(.opened-box) .largeImage').forEach(function(image) {
                image.removeAttribute('src');
            });
        });
    });
    // A function to control the closing of the lightbox
    function closeBox() {
        document.querySelector('.individual-lightbox.opened-box').classList.remove('opened-box');
    };
    // Closes the lightbox on click
    var closers = document.querySelectorAll('.close-lightbox, .backDrop');
    closers.forEach(function(closer) {
        closer.addEventListener('click', function() {
            closeBox();
        });
    });
});

// Resizing Script
if (lightBoxElements.length > 0) {
    var imageContainers = document.querySelectorAll('.image-gallery .image-container');
    
    function toggleCaptions() {
        var windowHeight = window.innerHeight;
        imageContainers.forEach(function(imageContainer) {            
            if (windowHeight < 500) {
                imageContainer.classList.add('contain-size');
            } else if (windowHeight >= 500 && imageContainer.classList.contains('contain-size')) {
                imageContainer.classList.remove('contain-size');
            }
        });
    }
    
    window.addEventListener('load', function() {
        toggleCaptions();
    });
    
    window.addEventListener('resize', function() {
        toggleCaptions();
    });
}
